// extracted by mini-css-extract-plugin
module.exports = {"button":"NavigationBarTextButton_button__pPd_a"};